// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../startOfWeek/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var startOfWeekWithOptions = convertToFP(fn, 2);
export default startOfWeekWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/startOfWeekWithOptions/index.js
// module id = 996
// module chunks = 0